// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__AER27","link":"Footer_link__NjPEc"};